import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import HasFeature from '@/shared/components/security/HasFeature';
import { canViewWizard, isCapacityPlanningAvailable } from './capacityPlanningAccess';
import CapacityPlanningWizard from './components/CapacityPlanningWizard';
const CapacityPlanningContainer = () => isCapacityPlanningAvailable() && canViewWizard() ? (_jsx(HasFeature, Object.assign({ feature: "CapacityPlanning" }, { children: _jsx(CapacityPlanningWizard, {}) }))) : null;
export default CapacityPlanningContainer;
